import React from "react";
import "./Skills.css";
const SkillApi = (props) => {
  console.log(props);
  const { name, image } = props.skill;
  return (
      
      <div data-aos="fade-up" className="col-md-3 col-sm-12 col-lg-3 project-hover project-semibox mb-5 p-3 rounded">
          <div style={{backgroundColor:"#000"}} className="card h-100   shadow">
            <div style={{ borderRadius: "20px" }} className="m-3 ">
              <img
                
                src={image}
                className="card-img-top"
                alt="..."
              />
            </div>
            <div className="card-body">
              <h3 className="card-title text-white">
                
                 {name}
               
              </h3>
              
            </div>
          </div>
        </div>
      


      



    // <div className="col-md-4 col-sm-12 col-lg-4 p-5 ">
    //   <div className="card  shadow p-3 bg-body rounded" style={{ width: "18rem" }}>
    //     <div className="p-5">
    //     <img src={image} className="card-img-top" alt="..." />
    //     </div>
    //     <div className="card-body">
    //       <h3 className=" text-center card-text">
    //         {name}
    //       </h3>
    //     </div>
    //   </div>
    // </div>
  );
};

export default SkillApi;
